import React from 'react';
import { Grid, Typography } from '@mui/material';
import { EventRepeat } from '@mui/icons-material';

type Props = {
  weekdayLabel: string;
  timeLabel: string;
  pageLabel: string;
  dateRangeLabel?: string;
};

export const ScheduleSelectionRow = ({ weekdayLabel, timeLabel, pageLabel, dateRangeLabel }: Props) => (
  <Grid container alignItems="center" flexWrap="nowrap" gap={1} py={0.5}>
    <EventRepeat fontSize="small" sx={{ color: 'text.secondary', flexShrink: 0 }} />
    <Typography variant="body2" fontWeight={600} sx={{ flexShrink: 0 }}>
      {weekdayLabel} {timeLabel}
    </Typography>
    <Typography variant="body2" color="text.secondary" noWrap>
      · {pageLabel}
    </Typography>
    {dateRangeLabel && (
      <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
        · {dateRangeLabel}
      </Typography>
    )}
  </Grid>
);
